/** NotFound — route catch-all (404). Tránh URL sai render thành trang trắng. */
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="gp-not-found" aria-labelledby="not-found-heading">
      <h1 id="not-found-heading">Không tìm thấy trang</h1>
      <p>Đường dẫn bạn truy cập không tồn tại.</p>
      {/* Link (không reload) — tránh mất token in-memory + cache khi điều hướng nội bộ SPA. */}
      <Link to="/">Về trang tổng quan</Link>
    </section>
  );
}
